import { Pipe, PipeTransform } from '@angular/core';
import { Status } from '../../core/models/status.model';

@Pipe({
  name: 'porsantType'
})
export class PorsantTypePipe implements PipeTransform {
  transform(value: any): any {
    switch (value) {
      case 1: return 'ثبت آگهی رایگان';
      case 2: return 'ثبت آگهی ویژه';
      case 3: return 'پاداش ادمین';
      case 4: return 'ثبت آگهی توسط زیر مجموعه';
    }
    return 'نامشخص';
  }
}
